import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import Cookie from 'js-cookie'

import student_Store from '../store/student_store'
import ExportCSV from '../functions/ExportCSV'
import Selector_Component from '../component/Selector_Component'
import supervisor_Store from '../store/supervisor_store'
import admin_Store from '../store/admin_store'
import CurrUser from '../functions/UserAuth'
import Student_Manage_Modal from '../component/Student_Manage_Modal'

function MyStudent_Page() {
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)

  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor)

  const supervisor_students = supervisor_Store(
    (state) => state.supervisor_students
  )
  const getsupervisorStudents = supervisor_Store(
    (state) => state.getsupervisorStudents
  )

  const columns = [
    {
      name: 'ID',
      selector: (row, index) => (index + 1),
      sortable: true,
      width: '100px',
      id: 1,
    },
    {
      name: 'Email',
      selector: (row) => row?.email,
      sortable: true,
      id: 2,
    },
    {
      name: 'name',
      selector: (row) => row?.name,
      id: 3,
    },
    {
      name: 'major',
      selector: (row) => row?.majors?.[0]?.name ?? '',
      id: 4,
    },
    {
      name: 'cohort',
      selector: (row) => row?.cohorts?.[0]?.name ?? '',
      id: 5,
    },
    {
      name: 'Status',
      selector: (row) => row?.status,
      id: 6,
    },
  ]

  let [mydata, setMydata] = useState([])
  useEffect(() => {
    getsupervisorStudents()
  }, [])

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage)
  }

  const handlePageChange = (page) => {
    setPage(page)
  }
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)

  function onChange(e) {
    let word = e.target.value
    const result = supervisor_students.student.filter(
      (student) =>
        (student.name &&
          student.name.toLowerCase().includes(word.toLowerCase())) ||
        student.email.includes(word) ||
        student?.id == word
    )
    setMydata(result)

    if (word === '') {
      setMydata([])
      setResetPaginationToggle(!resetPaginationToggle)
    }
  }

  function exportTable() {
    let arr = mydata.length > 0 ? mydata : supervisor_students.student
    arr.forEach((obj, index) => (obj.id = index + 1))
    arr.forEach((obj) => delete obj.image)
    arr.forEach((obj) => delete obj.roles)
    arr.forEach((obj) => obj.majors = obj?.majors?.[0]?.name ?? '')
    arr.forEach((obj) => (obj.cohorts = obj?.cohorts?.[0]?.name ?? ''))
    arr.forEach((obj) => (obj.created_at = new Date(obj?.created_at ?? '')?.toLocaleString()?.replace(',', '-') ?? ''))
    // return;
    ExportCSV(arr, 'Supervisor_students')
  }
  return (
    <>
      <div className='d-flex bd-highlight'>
        <div className='pt-2 flex-grow-1 bd-highlight'>
          <input
            type='text'
            onChange={(e) => onChange(e)}
            className='form-control w-50'
            placeholder='Search..'
            required
            aria-label=''
            aria-describedby='basic-addon1'
          />
        </div>

        <div className='p-2 bd-highlight'>
          <button
            onClick={async function () {
              exportTable()
            }}
            className='btn   btn-md btn btn-outline-primary'
            type='button'
          >
            CSV
          </button>
        </div>
      </div>
      {/* <h1>{tokennn}</h1> */}
      <DataTable
        title='Students'
        columns={columns}
        data={mydata?.length > 0 ? mydata : supervisor_students.student}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0
            ? mydata?.length
            : supervisor_students?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  )
}

export default MyStudent_Page
